module.exports = __webpack_public_path__ + "static/media/road.4bb8e631.png";